import React from 'react';
import { motion } from 'framer-motion';

const Projects = () => {
  const projects = [
    {
      name: "BMI Calculator: ReactJS",
      description: "BMI Calculator, developed using React. This project allows users to calculate their Body Mass Index (BMI) based on their height and weight.",
      deployedLink: "https://basicbmicalculator.web.app/"
    },
    {
      name: "Movie Search App: React, OMDB API",
      description: "Movie Search App, developed using React and the OMDB API. This project allows users to search for movies and view detailed information about their favorite films seamlessly.",
      deployedLink: "https://globalsearchformovies.web.app/"
    },
    {
      name: "Flashcard App: MERN Stack",
      description: "Flashcard App, developed using the MERN stack. This project aims to enhance learning efficiency through interactive flashcards, allowing users to create, update, and study their own sets of questions and answers seamlessly.",
      deployedLink: "https://studywithflashcards.web.app/"
    },
    {
      name: "Sudoku Solver: ReactJS, Back Tracking",
      description: "Sudoku Solver application using React JS and Node.js. This app allows users to input a Sudoku puzzle, solves it using a backtracking algorithm on a Node.js server, and displays the solved puzzle in real-time.",
      deployedLink: "https://ag-sudoku-solver.web.app/"
    },
    {
      name: "QR Code Generator: ReactJS, QRServer API",
      description: "QR Code Generator application that allows users to input a URL and generate a QR code for it. Users can also download the generated QR code.",
      deployedLink: "https://ag-qr-generator-app.web.app/"
    },
    {
      name: "Live Crypto Rates: ReactJS, CoinGekko API",
      description: "Build using ReactJS and CoinGekko API. This app allows users to search for specific cryptocurrencies and view their current prices, all-time highs (ATH), all-time lows (ATL), and respective dates.",
      deployedLink: " https://ag-livecrypto-app.web.app"
    },
    {
        name: "Student Management System: MERN Stack",
        description: " I built a comprehensive Student Management System using the MERN stack. This application allows for the creation, updating, and deletion of student records. It was a fantastic experience to implement CRUD operations and manage state effectively.",
        deployedLink: "https://agsmswithmern.web.app"
      },
      {
        name: "Enquiry Form with OTP Verification!",
        description: "Enquiry Form application with OTP verification using Firebase! This project allowed users to submit their name, query, and phone number, which then sends an OTP for verification before storing the data securely in Firebase.",
        deployedLink: "https://agfbotpauth24june24.web.app/"
      },
  ];


  return (
    <div className="min-h-screen bg-gray-100 flex flex-col items-center justify-center px-4 md:px-8 lg:px-16" id="projects">
      <h1 className="text-2xl md:text-4xl font-bold mb-8">Projects</h1>
      <div className="max-w-7xl w-full grid gap-8 grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-4 justify-items-center">
        {projects.map((project, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: index * 0.1 }}
            className="bg-white p-6 rounded-lg shadow-lg w-full"
          >
            <h2 className="text-xl md:text-2xl font-semibold">{project.name}</h2>
            <p className="text-gray-700">{project.description}</p>
            {project.deployedLink && (
              <a href={project.deployedLink} target="_blank" className="text-blue-500 hover:underline" rel="noreferrer">Deployed Link</a>
            )}
          </motion.div>
        ))}
      </div>
    </div>
  );
  
};

export default Projects;